import { render, staticRenderFns } from "./BuildingStub.vue?vue&type=template&id=3a20eef8&scoped=true&"
import script from "./BuildingStub.vue?vue&type=script&lang=js&"
export * from "./BuildingStub.vue?vue&type=script&lang=js&"
import style0 from "./BuildingStub.vue?vue&type=style&index=0&id=3a20eef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20eef8",
  null
  
)

export default component.exports